import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {revisarResources} from "../endpoints";

class DialogRevisarConteo extends React.Component{
    constructor(props) {
        super(props);
        if(props.tipo === "agrupado"){
            this.state = {
                iniciar:true,
                id_codigo_tipo: props.conteo.id_codigo_tipo,
                barra: props.conteo.codigo,
                tag: this.props.tag,
                revisar: this.props.revisar,
                desrevisar: !this.props.revisar,
                origen: this.props.origen
            }
        }
        else{
            this.state = {
                iniciar:true,
                id_conteo: props.conteo.id,
                revisar: this.props.revisar,
                desrevisar: !this.props.revisar,
                origen: this.props.origen
            }
        }
    }

    revisarConteo = () =>{
        if(this.props.tipo === "desagrupado"){
            revisarResources.revisarConteo(this.state.id_conteo,this.state.origen).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado","error")
                console.log(error)
            });
        }
        else{
            revisarResources.revisarConteoAgrupado(this.state.tag,this.state.barra,this.state.id_codigo_tipo,this.state.origen).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado","error")
                console.log(error)
            });
        }
    }

    getEventType = (event) =>{
        if(event.keyCode === 13){
            if(this.state.revisar){
                this.revisarConteo()
            }
            else{
                this.desrevisarConteo()
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.getEventType, false);
    }

    componentDidMount() {
        document.addEventListener('keyup', this.getEventType, false);
    }

    desrevisarConteo = () =>{
        if(this.props.tipo === "desagrupado"){
            revisarResources.desrevisarConteo(this.state.id_conteo).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado","error")
                console.log(error)
            });
        }
        else{
            revisarResources.desrevisarContepAgrupado(this.state.tag,this.state.barra,this.state.id_codigo_tipo).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado","error")
                console.log(error)
            });
        }
    }

    render() {
        return (
            <div>
                <Dialog
                    open={this.state.iniciar}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">Revisar conteo</DialogTitle>
                    <DialogContent>
                        {this.state.revisar &&
                            <DialogContentText id="alert-dialog-description">
                                Está seguro que desea marcar el conteo como revisado?
                            </DialogContentText>
                        }
                        {this.state.desrevisar &&
                        <DialogContentText id="alert-dialog-description">
                            Está seguro que desea marcar el conteo como NO revisado?
                        </DialogContentText>
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                            Cancelar
                        </Button>
                        { this.state.revisar &&
                            <Button variant="contained" color="primary" onClick={this.revisarConteo}>
                                Confirmar
                            </Button>}
                        { this.state.desrevisar &&
                        <Button variant="contained" color="primary" onClick={this.desrevisarConteo}>
                            Confirmar
                        </Button>}
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default DialogRevisarConteo;
